// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604130933/js/" + chunkId + "." + {"44":"2cff84e9","225":"69fdce18","481":"a0a3cd28","486":"242726e7","770":"6bcec864"}[chunkId] + ".0.44134876209334495.chunk.js";
};